import { useEffect, useState, type ReactNode } from "react";

type Props = {
  src: string;
  alt: string;
  fallback: ReactNode;
};

export function AssetImage({ src, alt, fallback }: Props) {
  const [ok, setOk] = useState<boolean | null>(null);

  useEffect(() => {
    let gone = false;
    const img = new Image();
    img.onload = () => {
      if (!gone) setOk(true);
    };
    img.onerror = () => {
      if (!gone) setOk(false);
    };
    img.src = src;
    return () => {
      gone = true;
    };
  }, [src]);

  if (ok === false) return <>{fallback}</>;
  if (ok === null) return <img src={src} alt={alt} />;

  return <img src={src} alt={alt} />;
}
